import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { VueQueryPlugin, MutationCache, type VueQueryPluginOptions } from '@tanstack/vue-query';
import App from './App.vue';
import { router } from './router';
import './assets/main.css';
import { ApiError } from './lib/api-client';
import { useToastStore } from './stores/toast';

const queryOptions: VueQueryPluginOptions = {
  queryClientConfig: {
    mutationCache: new MutationCache({
      onError: (error, _variables, _context, mutation) => {
        if (mutation.meta?.suppressToast) return;
        const toast = useToastStore();
        const message =
          error instanceof ApiError
            ? error.message || 'Terjadi kesalahan pada permintaan.'
            : error instanceof Error
              ? error.message
              : 'Terjadi kesalahan sistem.';
        toast.error(message);
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        // Book availability changes when someone else rents a copy, so refetch
        // when the tab regains focus rather than trusting a long cache.
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          // Retrying a 4xx just repeats the same rejection. Only transient
          // failures are worth a second attempt.
          if (error instanceof ApiError && error.status < 500) return false;
          return failureCount < 2;
        },
      },
      mutations: { retry: false },
    },
  },
};

const pinia = createPinia();
createApp(App).use(pinia).use(router).use(VueQueryPlugin, queryOptions).mount('#app');

